/**
 * LOT-UI-02 — Routeur dashboards par rôle.
 */
import React from 'react';
import { resolveMagasinRole } from '../../utils/roleRouting';
import DirecteurDashboard from './DirecteurDashboard';
import ResponsableDashboard from './ResponsableDashboard';
import VendeurDashboard from './VendeurDashboard';
import TechnicienDashboard from './TechnicienDashboard';

const RoleDashboard = ({ user, stats, caisseStatusByMagasin, openTicketsCount, t }) => {
  const mr = resolveMagasinRole(user);
  const username = user?.username || '';

  if (mr === 'super_admin' || (user?.role === 'admin' && !user?.magasin_role)) {
    return (
      <DirecteurDashboard
        stats={stats}
        caisseStatusByMagasin={caisseStatusByMagasin}
        openTicketsCount={openTicketsCount}
        t={t}
      />
    );
  }
  if (mr === 'admin_magasin') {
    return <ResponsableDashboard stats={stats} t={t} username={username} />;
  }
  if (mr === 'technicien') {
    return <TechnicienDashboard stats={stats} username={username} />;
  }
  return <VendeurDashboard stats={stats} username={username} t={t} />;
};

export default RoleDashboard;
